import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    gap: `${theme.spacing(5)} !important`,
    flexDirection: 'row',
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  videoContainer: {
    width: '254px !important',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  thumbnailImages: {
    width: '240px',
    height: '135px',
    cursor: 'pointer',
    marginBottom: theme.spacing(1.125),
    borderRadius: '4px',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  boldText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
  videoWrapper: {
    width: '400px',
    backgroundColor: theme.palette.textBackground.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3, 4),
    gap: theme.spacing(2),
    borderRadius: '4px',
    maxHeight: '239px',
    alignSelf: 'center',
  },
  thumbnailWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    opacity: '0.19',
    width: '78px',
    height: '50px',
    color: theme.palette.black.dark,
  },
  fieldsArnContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  noteText: {
    marginTop: '-16px',
    marginBottom: '-16px',
  },
}))
